import { GetPodcastMetricsResponse, getPodcastMetrics } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { usePodcast } from './PodcastContext';
import { metricsQueries } from './queryKeys';
import { podcastMetricsSelector } from './selectors';

type QueryKey = ReturnType<typeof metricsQueries.general>;

function useGetPodcastMetrics<TData = GetPodcastMetricsResponse>(
  opts?: Omit<
    UseQueryOptions<GetPodcastMetricsResponse, unknown, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  const { podcastId: id } = usePodcast();

  return useQuery<GetPodcastMetricsResponse, unknown, TData, QueryKey>(
    metricsQueries.general(id as string),
    ({ queryKey: [{ podcastId }] }) => getPodcastMetrics({ podcastId }),

    { enabled: !!id, ...opts },
  );
}

export function usePodcastMetrics() {
  return useGetPodcastMetrics({ select: podcastMetricsSelector });
}
